module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA10lEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4EiZxgYMBAMAFUDVcA1ANlAPfg0/P///+/fv0ASqOE/DODTAFQHRXJycDZQ+uTatS+uXltpbXNn796rO3ciNEAcjXDSihW9/XuB0jcvXrpz4MB8KcHzK5Y9vHkbyYbp0/0Kd8A1VHfth3j6+MZNE+ojImqLM1snHlu9GqHhDA60s7dvbmVoUaJHT0bCjoI8whqK8pxryyPnzu1vKAvJTDclrOEgI0OuAbd1s0qeDsd+JgZUDYQRORoGKQAAL9nJZWC5dE8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BM.png
// module id = 1094
// module chunks = 0